import {
  LOYALTY_TRANSACTION_REQUESTING,
  LIST_LOYALTY_TRANSACTIONS_SUCCESS,
  RESET_LOYALTY_TRANSACTION_QUERY,
  RESET_LOYALTY_TRANSACTION_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  query: null,
  recordCount: null,
  isFetching: false,
  currentOrderId: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_LOYALTY_TRANSACTION_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case RESET_LOYALTY_TRANSACTION_QUERY: {
      return {
        ...state,
        query: null,
        recordCount: null
      };
    }
    case LOYALTY_TRANSACTION_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case LIST_LOYALTY_TRANSACTIONS_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.loyaltyTransactions.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        data,
        query,
        isFetching: false,
        currentOrderId: null,
        recordCount: action.payload.total
      };
    }
    default:
      return state;
  }
};

export default reducer;
